import React from 'react';
import { Box, Typography, Container, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const NosotrosFAQ = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <Box sx={{ py: { xs: 8, md: 10 }, bgcolor: '#fbfcfd' }}>
            <Container maxWidth="md">
                <Typography variant="h3" align="center" sx={{ mb: { xs: 6, md: 8 }, fontWeight: 800, color: '#4e429c' }}>
                    Preguntas Frecuentes
                </Typography>
                {data.map((faq, index) => (
                    <Accordion key={index} sx={{ 
                        mb: 2, 
                        boxShadow: '0 4px 12px rgba(0,0,0,0.03)', 
                        borderRadius: '12px !important',
                        '&:before': { display: 'none' }, 
                        border: '1px solid #eee',
                        overflow: 'hidden'
                    }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#4e429c' }} />}>
                            <Typography sx={{ fontWeight: 800, color: '#4e429c', fontSize: '1.1rem' }}>
                                {faq.question}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ bgcolor: '#fff' }}>
                            <Typography sx={{ color: '#666', lineHeight: 1.6 }}>
                                {faq.answer}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Container>
        </Box>
    );
};

export default NosotrosFAQ;
